// Pure builder for the '.editable' cell menu, mirroring js/calendar.v2.8.js:679-738 exactly.

import { addGroupAction, pasteAction, undoAction } from './actions';
import { t } from './legacy';
import { MenuEntry } from './menu';

export function buildCellMenu(cell: HTMLElement, canUndo: boolean): MenuEntry[] {
  const row = cell.closest('tr');
  const groupIds = (cell.dataset.rowGroupIds ?? '').split(',').filter(Boolean);
  const groupNames = (row?.dataset.groupsNames ?? '').split(',');
  const editableGroups = (cell.dataset.editGroups ?? '').split(',').filter(Boolean);
  const rowId = Number(cell.dataset.idRow ?? 0);
  const column = Number(cell.dataset.column ?? 0);

  const addItems: MenuEntry[] = [];
  let hasGroup = false;
  groupIds.forEach((id, idx) => {
    if (!id || id === 'null' || id === 'undefined') return;
    if (!editableGroups.includes(id)) return;
    hasGroup = true;
    const name = groupNames[idx] || `${t('js.ctx_group_fallback', 'Group')} ${id}`;
    addItems.push({ label: `${t('js.ctx_add_event', 'Add event')} ${name}`, icon: 'edit', run: addGroupAction(rowId, column, id, name) });
  });

  const pasteItem: MenuEntry = { label: t('js.ctx_paste_event', 'Paste event'), icon: 'paste', run: pasteAction(rowId, column) };
  const undoItem: MenuEntry = { label: t('js.ctx_undo', 'Undo last change'), icon: 'undo', run: undoAction() };
  const quitItem: MenuEntry = { label: t('js.ctx_quit', 'Close'), icon: 'quit', run: () => undefined };

  if (!hasGroup) {
    return canUndo ? [pasteItem, undoItem, { separator: true }, quitItem] : [pasteItem, { separator: true }, quitItem];
  }
  const items: MenuEntry[] = [...addItems, pasteItem];
  if (canUndo) items.push(undoItem);
  items.push({ separator: true }, quitItem);
  return items;
}
